import i18n from "../i18n";

export const getOrderStates = () => ({
  PENDING: {
    value: "pending",
    label: i18n.t("common.orderStates.pending.label"),
    color: "warning",
    description: i18n.t("common.orderStates.pending.description"),
  },
  GOT_RESOURCE: {
    value: "GOT_RESOURCE",
    label: i18n.t("common.orderStates.gotResource.label"),
    color: "info",
    description: i18n.t("common.orderStates.gotResource.description"),
  },
  IN_USE: {
    value: "IN_USE",
    label: i18n.t("common.orderStates.inUse.label"),
    color: "success",
    description: i18n.t("common.orderStates.inUse.description"),
  },
  SUSPENDED: {
    value: "SUSPENDED",
    label: i18n.t("common.orderStates.suspended.label"),
    color: "warning",
    description: i18n.t("common.orderStates.suspended.description"),
  },
  USED_UP: {
    value: "USED_UP",
    label: i18n.t("common.orderStates.usedUp.label"),
    color: "error",
    description: i18n.t("common.orderStates.usedUp.description"),
  },
  EXPIRED: {
    value: "EXPIRED",
    label: i18n.t("common.orderStates.expired.label"),
    color: "error",
    description: i18n.t("common.orderStates.expired.description"),
  },
  CANCELLED: {
    value: "CANCELLED",
    label: i18n.t("common.orderStates.cancelled.label"),
    color: "default",
    description: i18n.t("common.orderStates.cancelled.description"),
  },
  REVOKED: {
    value: "REVOKED",
    label: i18n.t("common.orderStates.revoked.label"),
    color: "error",
    description: i18n.t("common.orderStates.revoked.description"),
  },
});

export const getOrderState = (status) => {
  const orderStates = getOrderStates();
  return (
    orderStates[status.toUpperCase()] || {
      value: status,
      label: status,
      color: "default",
      icon: "help_outline",
      description: i18n.t("common.orderStates.unknown.description"),
    }
  );
};
